var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrierOnboardingRmis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 238 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.254 84.281h-7.395v14.006h7.395V84.28Z",
    fill: "#575C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.258 98.289h2.471V84.284h-2.471v14.005Z",
    fill: "#CACCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.859 98.287H164.42v4.112h11.439v-4.112Z",
    fill: "#575C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.862 102.402h18.547V98.29h-18.547v4.112Z",
    fill: "#CACCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.749 85.081-41.937-.8V12.126l41.937-1.085v74.04Z",
    fill: "#575C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.407 75.802h-36.236V15.097l36.236-.88v61.585Z",
    fill: "#33CC60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.652 82.482-3.903 2.6V11.04l3.903 1.73v69.711Z",
    fill: "#CACCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.18 114.848H65.514v5.415H96.18v-5.415Z",
    fill: "#0CA933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.69 104.979h-29.832V189h29.832v-84.021Z",
    fill: "#929AA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.453 102.399h-49.095v3.901h7.376V189h3.124v-84.021h29.832V189h4.419v-81.837h4.344v-4.764Z",
    fill: "#575C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.889 116.51H67.431v-5.309h35.458c1.052 0 1.905.849 1.905 1.898v1.507a1.895 1.895 0 0 1-1.905 1.904Z",
    fill: "#929AA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.873 52.747H30.76s7.531.726 8.689 7.077c1.157 6.352 22.3 82.991 22.3 82.991h41.421s16.077 14.44 2.751 14.44H34.668L7.873 52.747Z",
    fill: "#929AA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.811 98.287h-3.255V89.41h3.255c1.158 0 2.098.936 2.098 2.09v4.69a2.093 2.093 0 0 1-2.098 2.096Z",
    stroke: "#929AA1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.375 126.509s22.593-2.339 37.076 6.426c14.483 8.764 14.241 11.468 13.612 31.242-.566 17.857-1.736 20.946-1.736 20.946L136.916 189h-19.12s1.157-30.077-10.139-37.96c-11.297-7.884-34.761-9.93-34.761-9.93l3.479-14.601Z",
    fill: "#0CA933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.072 79.797s9.622-5.074 11.788-.627c2.166 4.448 2.72 5.98 1.743 6.463-.977.484-2.023.137-2.652-.763-.628-.905.069-3.541-1.811-4.242-1.886-.695-3.417-.347-4.531.136-1.114.484-3.485 1.948-3.485 1.948l-1.052-2.915Z",
    fill: "#B76042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48 78.302s6.243-5.192 10.992-3.827c2.185.626 4.793 3.101 4.793 3.101s.417 1.154-.411 1.805c-.822.651-2.49-.806-2.49-.806s-3.473-2.984-8.402.23l-2.826 2.021-1.656-2.524Z",
    fill: "#B76042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.387 82.321c-5.658-10.098-15-3.994-15-3.994l-15.162 9.155 4.519 6.42 6.952-3.598s1.114-.378 2.172-1.08c1.083-.713 2.341-1.122 3.641-1.122h2.614c.866 0 1.669-.59 1.805-1.439a1.735 1.735 0 0 0-1.711-2.022h-1.338c-1.17 0-1.886-.416-1.519-1.52.056-.18.436-.924.498-1.004.473-.565 1.064-1.328 4.282-1.477 2.384-.111 4.089 1.607 5.34 3.331 1.258 1.724 2.197.937 2.197.937s1.805-.552.71-2.587Z",
    fill: "#DEA881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.375 127.948s30.603.558 35.24 13.546c4.637 12.988 3.573 29.463 2.994 43.896-.959 0 11.297 3.61 11.297 3.61h-18.753s.049-32.892-9.224-38.462c-10.208-6.135-18.075-5.558-18.075-5.558l-26.066-.291s-12.454-1.446-12.454-9.236c0-7.791 35.04-7.505 35.04-7.505Z",
    fill: "#33CC60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.566 48.275S34.66 51.159 34.66 69.06v69.277L86.8 127.948l-3.473-31.175s17.377 9.813 31.282-6.928c-4.637-6.928-6.952-10.39-6.952-10.39s-13.033 9.813-13.905 6.929c-.871-2.884-2.029-6.352-3.473-13.857-1.45-7.505 0-20.493-13.904-24.246-.579 26.845 0 48.492 0 48.492l-16.22-48.498h-11.59Z",
    fill: "#0CA933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.52 82.092s9.622-5.074 11.788-.627c2.16 4.447 2.72 5.98 1.743 6.463-.978.484-2.023.137-2.652-.763-.628-.905.069-3.541-1.811-4.242-1.886-.695-3.417-.347-4.531.136-1.114.484-3.485 1.948-3.485 1.948l-1.052-2.915ZM128.096 91.451h-6.815v-3.095h6.815c.617 0 1.115.497 1.115 1.11v.881a1.11 1.11 0 0 1-1.115 1.104Z",
    fill: "#B76042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.928 80.59s6.243-5.191 10.992-3.826c2.185.626 4.792 3.1 4.792 3.1s.417 1.155-.41 1.806c-.828.651-2.49-.806-2.49-.806s-3.473-2.984-8.402.229l-2.814 2.022-1.668-2.524Z",
    fill: "#B76042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.673 89.777 15.162-9.155s9.348-6.104 15 3.994c1.102 2.035-.71 2.58-.71 2.58s-.939.782-2.197-.936c-1.257-1.725-2.303-4.54-5.514-4.224-3.206.31-4.463 1.693-4.936 2.258-.473.564-.678 3.876-1.556 5.6-.877 1.725-3.784 2.711-3.784 2.711l-6.952 3.598-4.513-6.426Z",
    fill: "#DEA881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.14 65.599s11.005 41.564 48.66 41.564c23.172 0 34.761-10.39 34.761-10.39l-6.952-13.856s-14.483 14.718-31.282 10.389c-16.799-4.33-25.201-16.74-27.809-27.713",
    fill: "#0CA933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.14 65.599s11.005 41.564 48.66 41.564c23.172 0 34.761-10.39 34.761-10.39l-6.952-13.856s-14.483 14.718-31.282 10.389c-16.799-4.33-25.201-16.74-27.809-27.713",
    stroke: "#E9EBEC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.016 46.836h26.359V28.65h3.473V7.685H50.956l-.436 17.43s-3.983.65-3.983 3.826 4.058 3.462 4.058 3.462l-.579 14.433Z",
    fill: "#DEA881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.624 22.515h1.525c2.59 0 4.68-2.102 4.662-4.676l-.075-8.814h24.211c3.405 0 6.168-2.754 6.168-6.147V0s-2.16 2.816-8.016 2.816h-22.17c-3.486 0-6.305 2.816-6.305 6.283v13.416Z",
    fill: "#0CA933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.893 98.72 27.815-4.546v8.225h-27.815v-3.678Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.899 98.72h-23.825v3.679h23.825v-3.678Z",
    fill: "#929AA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.233 94.174h22.382l-27.722 4.547h-23.819l29.159-4.547ZM234.602 102.399h-84.149v3.678h84.149v-3.678ZM228.303 106.083h-82.194V189h82.194v-82.917Z",
    fill: "#CACCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.795 156.666h-20.421v-8.188a4.081 4.081 0 0 1 4.089-4.075h12.236a4.08 4.08 0 0 1 4.089 4.075v8.188h.007Z",
    stroke: "#0CA933",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.89 85.404h-5.502v16.995h5.502V85.404Z",
    fill: "#929AA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.89 102.404h7.849V85.408h-7.849v16.996Z",
    fill: "#CACCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.006 153.205h-43.667V189h43.667v-35.795Z",
    fill: "#33CC60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6 188.998h7.736v-35.795H186.6v35.795Z",
    fill: "#0CA933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.854 162.875H40.026l-4.344-5.626h47.066l-2.894 5.626Z",
    fill: "#929AA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.107 162.875h-9.292l2.197-5.626h9.99l-2.895 5.626ZM65.514 176.079v-2.016h-5.066v2.016c0 4.466-3.63 8.082-8.11 8.082H36.404v4.621H93.61v-4.621H73.624c-4.482 0-8.11-3.616-8.11-8.082Z",
    fill: "#575C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.485 152.771c-.293-3.753-.007-7.741-4.637-7.797-4.625-.05-45.187.291-45.187.291l-6.118-28.575h40.444a2.819 2.819 0 0 0 2.826-2.816 2.819 2.819 0 0 0-2.826-2.816H27.342L16.126 58.671s-2.315-7.214-9.267-5.775C-.093 54.341-.38 62.423.199 65.599c.579 3.176 4.345 8.659 8.689 9.527 3.187 12.12 18.249 82.123 18.249 82.123h53.875s3.765-.726 3.473-4.478Z",
    fill: "#CACCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.873 116.69H31.207v3.92h30.666v-3.92ZM65.305 160.759h-5.08V189h5.08v-28.241Z",
    fill: "#929AA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.858 104.979 29.832 33.358v-33.358h-29.832Z",
    fill: "#575C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.854 38.301h-.728c-4.077 0-7.388-3.293-7.388-7.362",
    stroke: "#B76042",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.916 21.759h-.578a.724.724 0 0 1-.729-.726V16.68c0-.403.324-.726.729-.726h.578c.405 0 .729.323.729.726v4.354c0 .397-.33.726-.729.726Z",
    fill: "#0CA933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.407 169.946H238",
    stroke: "#0CA933",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M194.407 70.257h-36.236v5.545h36.236v-5.545ZM158.171 15.097l36.236-.88v3.826l-36.236.863v-3.809Z",
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.443 45.955 6.441 9.15 13.338-18.944-2.533-3.604-10.749 15.259-3.877-5.502-2.62 3.641Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h238v189H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierOnboardingRmis);
export default __webpack_public_path__ + "static/media/carrier-onboarding-rmis.1417675f2980627724e67836ab68c532.svg";
export { ForwardRef as ReactComponent };